import type { Size } from '../types';

export interface PaginationProps {
  totalPages: number;
  currentPage: number;
  onPageChange?: (page: number) => void;
  size?: Exclude<Size, 'md'>;
  /** Pill-shaped (rounded) items. */
  rounded?: boolean;
  className?: string;
}

/** Bootstrap 5 pagination. */
export function Pagination({
  totalPages,
  currentPage,
  onPageChange,
  size,
  rounded = false,
  className = '',
}: PaginationProps) {
  const go = (p: number) => (e: React.MouseEvent) => {
    e.preventDefault();
    if (p >= 1 && p <= totalPages && p !== currentPage) onPageChange?.(p);
  };
  const sizeClass = size === 'sm' ? 'pagination-sm' : size === 'lg' ? 'pagination-lg' : '';
  const itemClass = rounded ? 'page-item' : 'page-item';

  return (
    <ul className={`pagination ${sizeClass} ${rounded ? 'pagination-rounded' : ''} ${className}`.trim()}>
      <li className={`${itemClass} ${currentPage === 1 ? 'disabled' : ''}`.trim()}>
        <a className="page-link" href="#" onClick={go(currentPage - 1)}>
          <i className="ph-caret-left" />
        </a>
      </li>
      {Array.from({ length: totalPages }, (_, i) => i + 1).map((p) => (
        <li className={`${itemClass} ${p === currentPage ? 'active' : ''}`.trim()} key={p}>
          <a className="page-link" href="#" onClick={go(p)}>
            {p}
          </a>
        </li>
      ))}
      <li className={`${itemClass} ${currentPage === totalPages ? 'disabled' : ''}`.trim()}>
        <a className="page-link" href="#" onClick={go(currentPage + 1)}>
          <i className="ph-caret-right" />
        </a>
      </li>
    </ul>
  );
}
